/**
 * 角色管理
 */
import React from 'react';
import {Button, Row, Col, Icon, Tooltip, Select, Tree, Modal} from 'antd';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import {global_data} from '../../ui/auth'
import {treeDataConversion} from "../../ui/treeData";
import PageLayout from "../../ui/PageLayout";

import RoleUserAdd   from "./RoleUserAdd";

const {TreeNode} = Tree;
const {confirm} = Modal;

class RoleIndex extends React.Component {
    columns = [{
        title: '用户名',
        dataIndex: 'username',
        width: '10%',
    }, {
        title: "名称/姓名",
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '用户类型',
        dataIndex: 'type',
        width: '10%',
        format: {0: '普通员工', 1: '开票人员', 2: "代办", 3: '租户', 4: "商城用户"}
    }, {
        title: '电话',
        dataIndex: 'tel',
        width: '10%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '10%',
        format: {0: '正常', 1: '删除', 2: '停用'}
    }, {
        title: '所属公司',
        dataIndex: 'memberName',
        width: '10%'
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '10%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("SYS_ROLE_USER_DELETE") ?
                    <Tooltip title="删除">
                        <Icon type="delete" theme="filled" title="删除" className="table-operate-icon"
                              onClick={this.delete.bind(this, record)}/>
                    </Tooltip>
                    : ""}
            </div>
        )
    }];

    state = {
        visible: false,
        loadData: '',

        menuTreeData: [],
        roleList: [],

        roleId: '',

        autoExpandParent: true,
        expandedKeys: [],
        checkedKeys: [],
        checkArr: [],
        selectedKeys: [],
        queryData: {},

        oldMenuChecks: [],
    };

    componentDidMount() {
        this.loadMenuTree()
        this.loadRoleList()
    }

    addUser = () => {
        this.showModal();
    }


    delete = (info, e) => {
        messager.confirm("是否从该角色删除该用户？", () => {
            const {roleId} = this.state;
            http.post({
                url: '/roleUser/delUserInRole',
                data: {roleId: roleId, username: info.username},
                success: (res) => {
                    this.state.loadData({roleId: roleId});
                    messager.notify("删除成功！");
                }
            });
        });
    }

    showModal = () => {
        this.setState({visible: true});
    };
    hiddenModal = () => {
        this.setState({visible: false});
    };
    loadMenuTree = () => {
        http.post({
            url: '/auth/findUserMenu',
            success: (res) => {
                treeDataConversion(res);
                this.setState({menuTreeData: res});
            }
        });

    }
    // ----选择框----
    handleSelectChange = (value) => {
        this.setState({
            selectedKeys: [],
            checkedKeys: [],
            checkArr: [],
            oldMenuChecks: []
        });
        console.log(`selected roleId: ${value}`);
        this.setState({
            roleId: value,
        });
        this.getRoleMenus(value)
        this.getUserList(value)
    };

    // 获取角色菜单
    getRoleMenus = (roleId) => {
        http.post({
            url: '/roleUser/findRoleMenus',
            data: {roleId: roleId},
            success: (res) => {
                if (res && res.length > 0) {
                    this.setState({
                        checkedKeys: res,
                        checkArr: res,
                        oldMenuChecks: res
                    });
                }
            }
        });
    }

    // 获取角色用户列表
    getUserList = (roleId) => {
        this.state.loadData({roleId: roleId})
    }

    // 刷新数据
    refreshData=()=>{
        const {roleId} = this.state;
        if (roleId === '' || roleId === undefined) {
            return
        }
        this.getRoleMenus(roleId)
        this.getUserList(roleId)
    }


    // ----树相关----
    // 加载角色列表
    loadRoleList = () => {
        http.post({
            url: '/auth/findAuthRole',
            success: (res) => {
                this.setState({roleList: res});
            }
        });

    }

    onExpand = expandedKeys => {
        console.log('onExpand', expandedKeys);
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    };

    onCheck = checkedKeys => {
        console.log('onCheck', checkedKeys);
        this.setState({checkedKeys, checkArr: checkedKeys.checked});
    };

    onSelect = (selectedKeys, info) => {
        console.log('onSelect', info);
        this.setState({selectedKeys});
    };

    renderTreeNodes = data =>

        data.map(item => {
            if (item.children) {
                return (
                    <TreeNode title={item.name} key={item.code} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode key={item.code} {...item} />;
        });

    // ----树相关----

    saveRoleMenus = () => {
        const {roleId, roleList,oldMenuChecks, checkArr} = this.state;
        if (checkArr.length === 0 || roleId === '' || roleList.length === 0) {
            return;
        }

        let oldMenuNameArr = []
        oldMenuChecks.forEach(menuCode => {
            oldMenuNameArr.push(this.findNameByKey(this.state.menuTreeData, menuCode))
        })

        let newMenuNameArr = []
        checkArr.forEach(menuCode => {
            newMenuNameArr.push(this.findNameByKey(this.state.menuTreeData, menuCode))
        })

        const {added, removed} = this.diffArray(oldMenuNameArr, newMenuNameArr);


        let roleName = roleList.find(d => d.roleId.toString() === roleId).roleName;
        let text = (
            <>
                <div>您修改了【{roleName}】的权限，变更如下：</div>
                {added.length > 0 && <div>新增：{added.join(",")}</div>}
                {removed.length > 0 && <div>删除：{removed.join(",")}</div>}
            </>
        );

        confirm({
            title: '是否保存【' + roleName + '】的权限?',
            content: text,
            onOk() {
                http.post({
                    url: '/roleUser/saveRoleMenus',
                    data: {roleId: roleId, menuCodes: checkArr.join(",")},
                    success: (res) => {
                        messager.notify("修改成功！");
                    }
                });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    }
    findNameByKey = (tree, code) => {
        for (let node of tree) {
            if (node.code === code) {
                return node.name;
            }
            if (node.children) {
                const result = this.findNameByKey(node.children, code);
                if (result) return result;
            }
        }
        return null; // 没找到
    }

    diffArray = (oldArr, newArr) => {
        // 新增的：在 newArr 里有，但 oldArr 里没有
        const added = newArr.filter(item => !oldArr.includes(item));

        // 删除的：在 oldArr 里有，但 newArr 里没有
        const removed = oldArr.filter(item => !newArr.includes(item));

        return {added, removed};
    }

    render() {
        return (
            <div style={{height: '100%'}}>
                <div style={{paddingBottom: 24}} ref={this.headerDiv}>
                    <Row>
                        <Col span={8}>
                            <Select
                                style={{width: 240, marginLeft: '10px', marginRight: '10px'}}
                                showSearch={true}
                                optionFilterProp="children"
                                onChange={this.handleSelectChange}
                                filterOption={(input, option) => option?.props?.children?.toLowerCase().includes(input.toLowerCase())}
                            >
                                {this.state.roleList.map(d => <Select.Option
                                    key={d.roleId}>{d.roleName}</Select.Option>)}
                            </Select>
                                <Icon style={{fontSize: '20px', alignSelf: 'center'}} onClick={this.refreshData} type="redo" />
                        </Col>
                        {global_data.authCode.includes("SYS_ROLE_USER_ADD") ?
                            <Col span={16} style={{textAlign: "right"}}>
                                <Button type="primary" onClick={this.addUser}>添加用户</Button>
                            </Col>
                            : ""}
                    </Row>
                </div>
                <div style={{display: 'flex'}}>
                    <div style={{height: '100%', width: '25%', marginRight: '5%'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px'}}>
                            {global_data.authCode.includes("SYS_ROLE_USER_MENU_SAVE") ?
                                <Button type="primary" onClick={this.saveRoleMenus}>保存角色权限</Button>
                                : ""}
                        </div>

                        <div style={{height: '680px', overflow: 'auto',}}>
                            <Tree
                                checkable
                                checkStrictly
                                onExpand={this.onExpand}
                                expandedKeys={this.state.expandedKeys}
                                autoExpandParent={this.state.autoExpandParent}
                                onCheck={this.onCheck}
                                checkedKeys={this.state.checkedKeys}
                                onSelect={this.onSelect}
                                selectedKeys={this.state.selectedKeys}
                            >
                                {this.renderTreeNodes(this.state.menuTreeData)}
                            </Tree>
                        </div>
                    </div>
                    <div style={{height: '700px', width: '70%', overflow: 'auto'}}>
                        <PageLayout
                            rowKey="username"
                            url="/roleUser/findUserByRoleIdPage"
                            columns={this.columns}
                            loadData={(func) => {
                                this.setState({loadData: func})
                            }}
                        />
                    </div>
                </div>
                <RoleUserAdd
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    roleId={this.state.roleId}
                    successCallback={() => this.state.loadData({ roleId: this.state.roleId })}
                />
            </div>
        )
    }

}

export default RoleIndex;
